import { http } from '../index';
import { formDataModifier } from '../modifiers';
import { downloadFileFromBytes, getFileNameFromContentDispositionString } from '../helpers';

export const getTrainingModuleFilesList = (trainingModuleId, params) =>
  http
    .get(`/training-modules/${trainingModuleId}/files/list`, { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

const fetchTrainingModuleFileBlob = (trainingModuleId, fileId) =>
  http
    .get(`/training-modules/${trainingModuleId}/files/${fileId}/download`, {
      responseType: 'blob',
    })
    .then(res => res)
    .catch(error => Promise.reject(error.response?.data || error));

export const openTrainingModuleFile = (trainingModuleId, fileId, fallbackFileName = '') =>
  fetchTrainingModuleFileBlob(trainingModuleId, fileId).then(res => {
    const fileName = getFileNameFromContentDispositionString(res) || fallbackFileName || 'file';
    const blob = res.data instanceof Blob ? res.data : new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);
    const openedWindow = window.open(url, '_blank', 'noopener,noreferrer');

    if (!openedWindow) {
      downloadFileFromBytes(res.data, fileName, '', true);
      window.URL.revokeObjectURL(url);
      return res;
    }

    window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    return res;
  });

export const downloadTrainingModuleFile = (trainingModuleId, fileId, fallbackFileName = '') =>
  fetchTrainingModuleFileBlob(trainingModuleId, fileId).then(res => {
    const fileName = getFileNameFromContentDispositionString(res) || fallbackFileName || 'file';
    downloadFileFromBytes(res.data, fileName, '', true);
    return res;
  });

export const uploadTrainingModuleFile = (trainingModuleId, file) =>
  http
    .post(`/training-modules/${trainingModuleId}/files`, formDataModifier({ file }), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteTrainingModuleFile = (trainingModuleId, fileId) =>
  http
    .delete(`/training-modules/${trainingModuleId}/files/${fileId}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);
